// CalculatingStrategy component - waiting view shown after strategy selection
// while the booking classification polls for the enrichment verdict

import { CircularProgress } from '@mui/material';
import * as styles from './CalculatingStrategy.css';

export const CalculatingStrategy = () => (
  <div className={styles.wrapper} data-testid="calculating-strategy">
    <CircularProgress color="info" />
    <h2 className={styles.title}>Calculating your strategy…</h2>
    <p className={styles.subtitle}>This will only take a moment.</p>
  </div>
);
